import ScoreboardImpl from './scoreboard.js';
import MojitoCore from 'mojito/core';
import { getPropTypes } from './utils';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A View that displays a scoreboard on the event page.
 *
 * @class Scoreboard
 * @name default
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * `Scoreboard` component prop types.
 *
 * @typedef ScoreboardPropTypes
 *
 * @property {object} event - The event to be displayed.
 * @property {boolean} [isOutright = false] - Indicates whether the outright scoreboard should be presented for an event.
 * @property {number} [inplayTime] - The amount of seconds which indicates how much time has passed since event became live.
 * @property {boolean} [hasClockDetails = false] - Event has clock details data. Which means that clocks are ticking for inplay event.
 *
 * @memberof Mojito.Presentation.Components.Scoreboard.default
 */
const propTypes = {
    ...getPropTypes(),
    isOutright: PropTypes.bool,
};

const defaultProps = {
    hasClockDetails: false,
    isOutright: false,
};

export default UIView('Scoreboard', ScoreboardImpl, propTypes, defaultProps);
